<script>
  export let percent = 0;
  export let cores = 0;
  export let model = '';
  export let perApp = [];
  export let showPerApp = false;

  function getColor(pct) {
    if (pct >= 80) return 'var(--neon-red)';
    if (pct >= 60) return 'var(--neon-orange)';
    return 'var(--neon-cyan)';
  }

  function formatMB(val) {
    return val > 1024 ? `${(val / 1024).toFixed(1)}GB` : `${val}MB`;
  }
</script>

<div class="monitor-card card">
  <div class="monitor-header">
    <div class="card-title">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6"/>
      </svg>
      {showPerApp ? 'CPU Usage (Per App)' : 'CPU Usage'}
    </div>
    <button class="toggle-view" on:click={() => showPerApp = !showPerApp} id="toggle-cpu-view">
      {showPerApp ? '← System View' : 'App Breakdown →'}
    </button>
  </div>

  {#if !showPerApp}
    <div class="system-view" id="cpu-system-view">
      <div class="big-stat">
        <span class="stat-value" style="color: {getColor(percent)}">{percent}%</span>
        <span class="stat-label">Total CPU</span>
      </div>
      <div class="progress-bar">
        <div class="progress-fill" style="width: {percent}%; background: {getColor(percent)}"></div>
      </div>
      <div class="stat-details">
        <span>{cores} cores</span>
        <span class="detail-sep">•</span>
        <span class="model-text">{model}</span>
      </div>
    </div>
  {:else}
    <div class="per-app-view" id="cpu-perapp-view">
      {#each perApp as app}
        <div class="app-cpu-row">
          <div class="app-cpu-info">
            <span class="app-cpu-name">{app.name}</span>
            <span class="app-cpu-pct" style="color: {getColor(app.percent)}">{app.percent}%</span>
          </div>
          <div class="progress-bar">
            <div class="progress-fill" style="width: {app.percent}%; background: {getColor(app.percent)}"></div>
          </div>
        </div>
      {/each}
    </div>
  {/if}
</div>

<style>
  .monitor-card {
    animation: fadeInUp 0.4s ease both;
  }

  .monitor-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .monitor-header .card-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 0;
  }

  .monitor-header .card-title svg {
    color: var(--neon-cyan);
  }

  .toggle-view {
    padding: 6px 14px;
    font-size: 12px;
    color: var(--neon-blue);
    border: 1px solid rgba(59, 130, 246, 0.3);
    border-radius: var(--radius-sm);
    background: rgba(59, 130, 246, 0.08);
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .toggle-view:hover {
    background: rgba(59, 130, 246, 0.15);
    border-color: var(--neon-blue);
  }

  .system-view {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .big-stat {
    display: flex;
    align-items: baseline;
    gap: 10px;
  }

  .stat-value {
    font-size: 42px;
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1;
  }

  .stat-label {
    font-size: 14px;
    color: var(--text-secondary);
    font-weight: 500;
  }

  .stat-details {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: var(--text-secondary);
    margin-top: 4px;
  }

  .detail-sep { opacity: 0.4; }

  .model-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 300px;
  }

  .per-app-view {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .app-cpu-row {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .app-cpu-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .app-cpu-name {
    font-size: 13px;
    font-weight: 500;
    color: var(--text-primary);
  }

  .app-cpu-pct {
    font-size: 14px;
    font-weight: 700;
  }
</style>
